import { data as payloadData } from "@escapio/shared/state/payload";
import { pageType } from "@escapio/portal/state/pageType";
import { getLoginPayload } from "@escapio/shared/state/login-cookie";

(async function () {
	const adminToolsUrl = getLoginPayload()?.adminToolsUrl;
	if (!adminToolsUrl) {
		return;
	}

	// Load admin tools data if possible (checks permissions).
	const url = new URL("https://" + window.location.host + adminToolsUrl);
	const formData = new FormData();
	formData.append("pageType", pageType);
	formData.append("pageSearchType", payloadData.page_search_type);
	if (payloadData?.hotel?.id) {
		formData.append("hotelId", payloadData.hotel.id);
	}
	if (payloadData?.listId) {
		formData.append("listId", payloadData.listId);
		const { hotel_list: hotels } = payloadData;
		formData.append(
			"hotelIds",
			hotels
				.filter(Boolean)
				.map(hotel => hotel.id)
				.join(","),
		);
	}

	const response = await fetch(url, { method: "POST", body: formData });
	if (!response.ok) {
		return;
	}
	const data = await response.json();
	if (data?.contractHotelIds) {
		// @TODO move this code into specific admin-tools bundle for hotel-list
		payloadData.hotel_list.forEach(hotel => {
			hotel.hasContract = data.contractHotelIds.includes(hotel.id);
		});
		// Hack: will force an update with new hotel data needed for contract filter
		const { store } = await import("../components/hotel-list/DataStore");
		store.dispatch(state => ({ ...state }));
	}

	// Load admin tools and start with data.
	const { load } = await import(data.tools_url);
	load(data);
})();
